import { Injectable } from '@angular/core';

@Injectable()
export class BrowserWindowRef {
  get nativeWindow(): Window & {
    installPwaEvent?: Event;
    cookiehub?: {
      load: (config?: any) => void;
    };
  } {
    return window;
  }
}
